import _ from 'lodash'
import {
  RESET_CHATLIST,
  FETCHING_CHATLIST,
  FETCH_CHATLIST_SUCCESS,
  FETCH_CHATLIST_FAIL,
  FILTER_CHATLIST,
  FETCH_WAITING_SUPPORT_COUNT
} from '../actions/types'

const INITIAL_STATE = {
  loading: false,
  resultNumber: 0,
  data: [],
  filteredData: [],
  errorMsg: null,
  waitingCount: 0
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_CHATLIST:
      return { ...state, ...INITIAL_STATE }
    case FETCHING_CHATLIST:
      return { ...state, loading: true }
    case FETCH_CHATLIST_SUCCESS:
      return {
        ...state,
        resultNumber: _.size(action.payload),
        data: action.payload,
        filteredData: action.payload,
        loading: false
      }
    case FETCH_CHATLIST_FAIL:
      return { ...state, ...INITIAL_STATE, errorMsg: action.payload }
    case FILTER_CHATLIST:
      const filter = action.payload
      let filteredData

      switch (filter) {
        case '対応待ち':
          filteredData = _.filter(state.data, (item) => {
            return !item.support_completed && item.waiting_support
          })
          break
        case '返事待ち':
          filteredData = _.filter(state.data, (item) => {
            return !item.support_completed && !item.waiting_support
          })
          break
        case '対応済':
          filteredData = _.filter(state.data, (item) => {
            return item.support_completed
          })
          break
        default:
          filteredData = _.map(state.data, item => {
            return item
          })
          break
      }
      return { ...state, resultNumber: filteredData.length, filteredData }
    case FETCH_WAITING_SUPPORT_COUNT:
      return { ...state, waitingCount: action.payload }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/chatReducer.js